// extracted by mini-css-extract-plugin
module.exports = {"divBackground":"LoadingScreen_divBackground__2F25L","spinner":"LoadingScreen_spinner__2akX9"};